import { render } from "./CapcityDayComponent.vue?vue&type=template&id=34f37986"
import script from "./CapcityDayComponent.vue?vue&type=script&lang=js"
export * from "./CapcityDayComponent.vue?vue&type=script&lang=js"

import exportComponent from "/Users/vincent/Herd/app.prixo.io/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__